import { SURFACE_CAP } from '@/lib/sync/create-surface';

/** A run still starting will add a surface, so it counts; one that could not
 *  start adds nothing. The server counts the same way when it accepts a run. */
export function isAtSurfaceCap(
  surfaceCount: number,
  pendingRows: readonly { couldNotStart: boolean }[],
): boolean {
  const starting = pendingRows.filter((row) => !row.couldNotStart).length;
  return surfaceCount + starting >= SURFACE_CAP;
}
